import { Link, type TLinkProps } from '~/components/link'
import type { TLinkSizes } from '~/components/link/types'
import {
  DISPLAY_NAME,
  type ScopedProps,
  useContentContext,
} from '../../content'

type IContentLinkProps = TLinkProps

export function ContentLink(props: IContentLinkProps) {
  const { children, testID, __scopeContent } =
    props as ScopedProps<IContentLinkProps>
  const { size } = useContentContext(DISPLAY_NAME, __scopeContent)

  const renderLabelSize = (): TLinkSizes => {
    if (size === 'default') {
      return 'md'
    }
    return 'ml'
  }

  return (
    <Link.Root testID={testID} size={renderLabelSize()}>
      <Link.Label>{children}</Link.Label>
    </Link.Root>
  )
}
